import { ButtonLink, Flex, Icon, LssProp, Text } from '@lucidhq/lucidium';
import { ReactNode } from 'react';
import { MdAddCircleOutline } from 'react-icons/md';

export interface CreateButtonProps {
  children: ReactNode;
  to: string;
  lss?: LssProp;
  onClick?: () => void;
}

export const CreateButton = ({
  children,
  to,
  lss = {},
  onClick,
}: CreateButtonProps) => (
  <ButtonLink
    lss={{ p: 'sm', width: '27%', ...lss }}
    type="button"
    to={to}
    onClick={onClick}
  >
    <Flex lss={{ alignItems: 'center', justifyContent: 'center' }}>
      <Icon as={MdAddCircleOutline} lss={{ textScale: 'heading6' }} />
      <Text lss={{ ml: 'sm' }}>{children}</Text>
    </Flex>
  </ButtonLink>
);
